import {
    AddToCart,
    AddToPreferences,
    QuickView,
} from '@/features/productSearch/ProductCardActions/index.js'

export const ProductContent = ({ item, productsInCart }) => {
    // useEffect(()=>{
    //     refetch();
    // }, [])

    return (
        <>
            <QuickView item={item} productId={item.product_id} />
            <AddToPreferences item={item} productId={item.product_id} />
            <AddToCart
                item={item}
                productId={item.product_id}
                cartContains={productsInCart?.data?.includes(item.product_id)}
            />
        </>
    )
}
